export default __webpack_public_path__ + "zwitsal-229ac5.png";